(function () {
  var activeModal = null;
  var productDataCache = {};
  var pcardViewItemListFired = Object.create(null);
  var SCROLL_LOCK_PADDING_ATTR = 'data-pcard-scroll-lock-padding';
  var PCARD_GA_GET_DEAL = 'get_deal';
  var PCARD_GA_LEARN_MORE = 'learn_more';
  var PCARD_GA_ATC_POP = 'atc_pop';
  var PCARD_GA_ATC_BUTTON_NAME = 'add to cart';

  function trackSelectContent(contentType, contentName, buttonName) {
    var typeLabel = (contentType || '').trim();
    var nameLabel = (contentName || '').trim();
    var buttonLabel = (buttonName || '').trim();
    if (!typeLabel || !nameLabel || !buttonLabel) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_content',
      event_parameters: {
        content_type: typeLabel,
        content_name: nameLabel,
        button_name: buttonLabel
      }
    });
  }

  function trackProductEntry(buttonName) {
    var buttonLabel = (buttonName || '').trim();
    if (!buttonLabel) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'product_entry',
      event_parameters: {
        button_name: buttonLabel
      }
    });
  }

  function getPcardListMeta(root) {
    var listId = (root.getAttribute('data-pcard-ga-list-id') || 'open_ear_stu_productcard').trim();
    var currency = (root.getAttribute('data-pcard-currency') || 'GBP').trim();

    return {
      listId: listId,
      listName: listId,
      currency: currency
    };
  }

  function getCardBadgeDiscountText(root, blockId) {
    var cartBtn = root.querySelector(
      '.section-open-eh-stu-productcard__cart-btn[data-pcard-modal-id="' + blockId + '"]'
    );
    if (!cartBtn) return '';

    var card = cartBtn.closest('.section-open-eh-stu-productcard__card');
    if (!card) return '';

    var badgeText = card.querySelector('.section-open-eh-stu-productcard__badge-text');
    return badgeText && badgeText.textContent ? badgeText.textContent.trim() : '';
  }

  function getPcardDiscountLabel(root, blockId, productData) {
    var fromDom = getCardBadgeDiscountText(root, blockId);
    if (fromDom) return fromDom;

    return productData && productData.badgeText ? String(productData.badgeText).trim() : '';
  }

  function getVariantColorLabel(variant, productData) {
    var colorOptionIndex = getColorOptionIndex(productData);
    if (colorOptionIndex < 0 || !variant) return 'none';

    var options = [variant.option1, variant.option2, variant.option3];
    var colorValue = options[colorOptionIndex] || '';
    var label = getColorBase(colorValue) || colorValue;

    if (!label || label === 'Default Title') return 'none';

    return label;
  }

  function getGaItemMetaFromSku(sku, variant, productData, state) {
    var itemName = productData.productTitle || '';
    var itemVariantLine = '';
    var itemCategory = '';
    var itemCategory2 = state && state.bandSize ? state.bandSize : 'Standard';

    if (typeof product_handle_valueMap !== 'undefined' && sku && product_handle_valueMap[sku]) {
      var mapped = product_handle_valueMap[sku];
      itemName = mapped[0] || itemName;
      itemVariantLine = mapped[1] || '';
      itemCategory = mapped[2] || '';
      if (mapped[3]) itemCategory2 = mapped[3];
    } else if (sku) {
      var skuMatch = sku.match(/^([A-Za-z]+\d+)/);
      if (skuMatch) itemCategory = skuMatch[1];
    }

    return {
      item_id: sku || String(variant.id),
      item_name: itemName,
      item_category: itemCategory,
      item_category2: itemCategory2,
      item_category3: getVariantColorLabel(variant, productData),
      item_variant: itemVariantLine
    };
  }

  function findVariantById(productData, variantId) {
    if (!productData || !productData.variants) return null;

    return (
      productData.variants.find(function (variant) {
        return variant.id === variantId;
      }) || null
    );
  }

  function getDefaultGaVariant(productData) {
    if (!productData || !productData.variants || !productData.variants.length) return null;

    return (
      productData.variants.find(function (variant) {
        return variant.available;
      }) || productData.variants[0]
    );
  }

  function buildPcardGaItem(root, productData, variant, state, options) {
    options = options || {};
    if (!variant || !productData) return null;

    var listMeta = getPcardListMeta(root);
    var sku = variant.sku || '';
    var meta = getGaItemMetaFromSku(sku, variant, productData, state || { bandSize: 'Standard' });
    var discount = getPcardDiscountLabel(root, productData.blockId, productData);
    var quantity = (state && state.quantity) || options.quantity || 1;
    var price = variant.price / 100;
    var itemListName = options.navigationItemListName
      ? 'Navigation_' + listMeta.listId
      : listMeta.listName;

    return {
      item_id: meta.item_id,
      item_name: meta.item_name,
      discount: discount,
      index: productData.blockIndex || 1,
      item_list_id: listMeta.listId,
      item_list_name: itemListName,
      item_category: meta.item_category,
      item_category2: meta.item_category2,
      item_category3: meta.item_category3,
      item_variant: meta.item_variant,
      item_brand: 'SHOKZ',
      price: price,
      quantity: quantity,
      currency: listMeta.currency
    };
  }

  function getViewItemListFireKey(blockId) {
    return window.location.pathname + '|' + blockId;
  }

  function hasViewItemListFired(blockId) {
    return !!pcardViewItemListFired[getViewItemListFireKey(blockId)];
  }

  function markViewItemListFired(blockId) {
    pcardViewItemListFired[getViewItemListFireKey(blockId)] = true;
  }

  function resetViewItemListFiredForPath(pathname) {
    var prefix = pathname + '|';
    Object.keys(pcardViewItemListFired).forEach(function (key) {
      if (key.indexOf(prefix) === 0) {
        delete pcardViewItemListFired[key];
      }
    });
  }

  function trackPcardSelectItem(root, buttonName, productData) {
    if (!productData) return;

    var listMeta = getPcardListMeta(root);
    var variant = getDefaultGaVariant(productData);
    var item = buildPcardGaItem(root, productData, variant, { bandSize: 'Standard' }, {
      navigationItemListName: true,
      quantity: 1
    });
    var buttonLabel = (buttonName || '').trim();

    if (!item || !buttonLabel) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        item_list_id: listMeta.listId,
        item_list_name: listMeta.listName,
        button_name: buttonLabel,
        items: [item]
      }
    });
  }

  function trackPcardViewItemList(root, productData) {
    if (!productData) return;

    var listMeta = getPcardListMeta(root);
    var variant = getDefaultGaVariant(productData);
    var item = buildPcardGaItem(root, productData, variant, { bandSize: 'Standard' }, {
      quantity: 1
    });

    if (!item) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'view_item_list',
      event_parameters: {
        currency: listMeta.currency,
        item_list_id: listMeta.listId,
        item_list_name: listMeta.listName,
        items: [item]
      }
    });
  }

  function destroyPcardViewItemListObserver(root) {
    if (root._pcardViewObserver) {
      root._pcardViewObserver.disconnect();
      delete root._pcardViewObserver;
    }
    delete root.dataset.pcardViewObserverBound;
  }

  function initPcardViewItemListObserver(root) {
    if (root.dataset.pcardViewObserverBound === 'true') return;
    root.dataset.pcardViewObserverBound = 'true';

    if (!('IntersectionObserver' in window)) return;

    destroyPcardViewItemListObserver(root);

    root._pcardViewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var sentinel = entry.target;
        var card = sentinel.closest('.section-open-eh-stu-productcard__card');
        if (!card || !root.contains(card)) return;

        var blockId = getCardBlockId(card);
        if (!blockId || hasViewItemListFired(blockId)) return;

        markViewItemListFired(blockId);
        trackPcardViewItemList(root, getProductData(blockId, root));
      });
    });

    root.querySelectorAll('[data-pcard-view-sentinel]').forEach(function (sentinel) {
      root._pcardViewObserver.observe(sentinel);
    });
  }

  function getCardBlockId(card) {
    if (!card) return '';

    var cartBtn = card.querySelector('.section-open-eh-stu-productcard__cart-btn[data-pcard-modal-id]');
    return cartBtn ? cartBtn.getAttribute('data-pcard-modal-id') || '' : '';
  }

  function resolvePcardSelectItemClick(root, event) {
    var scene = event.target.closest('.section-open-eh-stu-productcard__scene[data-pcard-scene-id]');
    if (scene && root.contains(scene)) {
      if (
        event.target.closest(
          '[data-pcard-zoom-in], [data-pcard-zoom-out], .section-open-eh-stu-productcard__scene-btn'
        )
      ) {
        return null;
      }

      return {
        blockId: scene.getAttribute('data-pcard-scene-id'),
        buttonName: 'product image'
      };
    }

    var title = event.target.closest('.section-open-eh-stu-productcard__title');
    if (title && root.contains(title)) {
      return {
        blockId: getCardBlockId(title.closest('.section-open-eh-stu-productcard__card')),
        buttonName: title.textContent ? title.textContent.trim() : ''
      };
    }

    var btn = event.target.closest('.section-open-eh-stu-productcard__btn');
    if (btn && root.contains(btn)) {
      return {
        blockId: getCardBlockId(btn.closest('.section-open-eh-stu-productcard__card')),
        buttonName: btn.textContent ? btn.textContent.trim() : ''
      };
    }

    return null;
  }

  function trackPcardAddToCart(root, submitBtn, productData, variant, state) {
    if (!variant || !productData) return;

    var listMeta = getPcardListMeta(root);
    var item = buildPcardGaItem(root, productData, variant, state, { quantity: state.quantity || 1 });
    var buttonName =
      submitBtn && submitBtn.textContent ? submitBtn.textContent.trim() : 'Add to Cart';

    if (!item) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'add_to_cart',
      event_parameters: {
        button_name: buttonName,
        currency: listMeta.currency,
        value: Number((item.price * item.quantity).toFixed(2)),
        item_list_id: listMeta.listId,
        item_list_name: listMeta.listName,
        items: [item]
      }
    });
  }

  function getGetDealButtonLabel(buttonEl) {
    return buttonEl && buttonEl.textContent ? buttonEl.textContent.trim() : '';
  }

  function getScrollbarWidth() {
    return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
  }

  function applyScrollbarPadding(el, scrollbarWidth) {
    if (!el || el.hasAttribute(SCROLL_LOCK_PADDING_ATTR)) return;

    var currentPadding = parseFloat(window.getComputedStyle(el).paddingRight) || 0;
    el.setAttribute(SCROLL_LOCK_PADDING_ATTR, String(currentPadding));
    el.style.paddingRight = currentPadding + scrollbarWidth + 'px';
  }

  function lockPageScroll() {
    var scrollbarWidth = getScrollbarWidth();

    document.documentElement.style.setProperty('--pcard-scrollbar-width', scrollbarWidth + 'px');
    document.body.classList.add('pcard-variant-modal-open');

    if (scrollbarWidth <= 0) return;

    [
      '.site-header',
      '#shopify-section-header',
      '#shopify-section-announcement',
      '.announcement-wrapper',
      '.section-open-eh-stu-nav.is-visible [data-oeh-stu-nav-bar]'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        applyScrollbarPadding(el, scrollbarWidth);
      });
    });
  }

  function unlockPageScroll() {
    document.body.classList.remove('pcard-variant-modal-open');
    document.body.style.paddingRight = '';
    document.documentElement.style.removeProperty('--pcard-scrollbar-width');

    document.querySelectorAll('[' + SCROLL_LOCK_PADDING_ATTR + ']').forEach(function (el) {
      el.style.paddingRight = '';
      el.removeAttribute(SCROLL_LOCK_PADDING_ATTR);
    });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 766px)').matches;
  }

  function getSceneById(sceneId) {
    if (!sceneId) return null;
    return document.querySelector('[data-pcard-scene-id="' + sceneId + '"]');
  }

  function setSceneZoomState(sceneId, isZoom) {
    var scene = getSceneById(sceneId);
    if (!scene) return;

    scene.classList.remove('state-normal', 'state-zoom');
    scene.classList.add(isZoom ? 'state-zoom' : 'state-normal');
  }

  function toggleSceneZoom(sceneId) {
    var scene = getSceneById(sceneId);
    if (!scene) return;

    var isZoom = scene.classList.contains('state-zoom');
    setSceneZoomState(sceneId, !isZoom);
  }

  window.oehStuPcardToggleSceneZoom = toggleSceneZoom;
  window.oehStuPcardSetSceneZoom = setSceneZoomState;

  function resetScenesInRoot(root) {
    root.querySelectorAll('[data-pcard-scene].state-zoom').forEach(function (scene) {
      scene.classList.remove('state-zoom');
      scene.classList.add('state-normal');
    });
  }

  function initPcardGaTracking(root) {
    if (root.dataset.pcardGaBound === 'true') return;
    root.dataset.pcardGaBound = 'true';

    root.addEventListener('click', function (event) {
      var selectItemClick = resolvePcardSelectItemClick(root, event);
      if (selectItemClick && selectItemClick.blockId) {
        trackPcardSelectItem(
          root,
          selectItemClick.buttonName,
          getProductData(selectItemClick.blockId, root)
        );
      }

      var pcardBtn = event.target.closest(
        '.section-open-eh-stu-productcard__btn[data-pcard-ga-track="get_deal"], .section-open-eh-stu-productcard__btn[data-pcard-ga-track="learn_more"]'
      );
      if (pcardBtn && root.contains(pcardBtn)) {
        var contentName = pcardBtn.getAttribute('data-pcard-ga-track');
        if (contentName === PCARD_GA_GET_DEAL || contentName === PCARD_GA_LEARN_MORE) {
          trackSelectContent(
            pcardBtn.getAttribute('data-pcard-ga-content-type'),
            contentName,
            getGetDealButtonLabel(pcardBtn)
          );
          return;
        }
      }

      var cartBtn = event.target.closest('.section-open-eh-stu-productcard__cart-btn[data-pcard-ga-track="atc_pop"]');
      if (cartBtn && root.contains(cartBtn)) {
        trackSelectContent(
          cartBtn.getAttribute('data-pcard-ga-content-type'),
          PCARD_GA_ATC_POP,
          PCARD_GA_ATC_BUTTON_NAME
        );
        return;
      }

      var viewAllLink = event.target.closest('.section-open-eh-stu-productcard__view-all[data-pcard-ga-track="product_entry"]');
      if (viewAllLink && root.contains(viewAllLink)) {
        trackProductEntry(viewAllLink.getAttribute('data-pcard-ga-button-name'));
      }
    });
  }

  function initSceneZoom(root) {
    if (root.dataset.pcardSceneBound === 'true') return;
    root.dataset.pcardSceneBound = 'true';

    root.addEventListener('click', function (event) {
      var zoomInBtn = event.target.closest('[data-pcard-zoom-in]');
      if (zoomInBtn) {
        event.preventDefault();
        setSceneZoomState(zoomInBtn.getAttribute('data-pcard-scene-target'), true);
        return;
      }

      var zoomOutBtn = event.target.closest('[data-pcard-zoom-out]');
      if (zoomOutBtn) {
        event.preventDefault();
        setSceneZoomState(zoomOutBtn.getAttribute('data-pcard-scene-target'), false);
      }
    });
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    if (typeof theme !== 'undefined' && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, format);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function isColorOption(name) {
    var optionName = (name || '').toLowerCase();
    return optionName === 'color' || optionName === 'kleur';
  }

  function getProductData(blockId, root) {
    if (productDataCache[blockId]) return productDataCache[blockId];

    var script = root.querySelector('[data-pcard-product-data="' + blockId + '"]');
    if (!script) return null;

    try {
      productDataCache[blockId] = JSON.parse(script.textContent);
      return productDataCache[blockId];
    } catch (error) {
      return null;
    }
  }

  function variantMatchesBandSize(variant, bandSize) {
    if (!bandSize) return true;
    var option1 = variant.option1 || '';
    var isMini = option1.indexOf(' Mini') !== -1;
    if (bandSize === 'Mini') return isMini;
    return !isMini;
  }

  function getBandSizeFromVariant(variant) {
    if (!variant || !variant.option1) return 'Standard';
    return variant.option1.indexOf(' Mini') !== -1 ? 'Mini' : 'Standard';
  }

  function normalizeSelectedColor(value, bandSize) {
    if (!value) return value;
    if (bandSize === 'Mini') {
      return value.indexOf(' Mini') !== -1 ? value : value + ' Mini';
    }
    return value.replace(/ Mini$/, '');
  }

  function getColorBase(value) {
    if (!value) return '';
    return value.replace(/ Mini$/, '').trim();
  }

  function productHasBandSize(productData) {
    return productData.variants.some(function (variant) {
      return (variant.option1 || '').indexOf(' Mini') !== -1;
    });
  }

  function getColorOptionIndex(productData) {
    if (!productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      if (isColorOption(productData.options[i].name)) {
        return productData.options[i].position - 1;
      }
    }
    return -1;
  }

  function hasColorOption(productData) {
    return getColorOptionIndex(productData) >= 0;
  }

  function getUniqueColorBases(productData) {
    var bases = [];
    var seen = {};

    productData.variants.forEach(function (variant) {
      var base = getColorBase(variant.option1);
      if (base && !seen[base]) {
        seen[base] = true;
        bases.push(base);
      }
    });

    return bases;
  }

  function variantMatchesSelectedOptions(variant, selectedOptions, bandSize, colorOptionIndex) {
    if (bandSize && !variantMatchesBandSize(variant, bandSize)) return false;

    var options = getVariantOptions(variant);

    return selectedOptions.every(function (selectedValue, index) {
      if (!selectedValue) return true;
      if (index === colorOptionIndex) {
        return options[index] === normalizeSelectedColor(selectedValue, bandSize);
      }
      return options[index] === selectedValue;
    });
  }

  function isColorBaseVisible(productData, baseColor, state) {
    var colorOptionIndex = getColorOptionIndex(productData);
    var trial = state.selectedOptions.slice();
    trial[colorOptionIndex] = baseColor;

    return productData.variants.some(function (variant) {
      return variantMatchesSelectedOptions(variant, trial, state.bandSize, colorOptionIndex);
    });
  }

  function isColorBaseAvailable(productData, baseColor, state) {
    var colorOptionIndex = getColorOptionIndex(productData);
    var trial = state.selectedOptions.slice();
    trial[colorOptionIndex] = baseColor;

    return productData.variants.some(function (variant) {
      if (!variant.available) return false;
      return variantMatchesSelectedOptions(variant, trial, state.bandSize, colorOptionIndex);
    });
  }

  function getFirstVisibleColorBase(productData, state) {
    var bases = getUniqueColorBases(productData);
    var i;

    for (i = 0; i < bases.length; i++) {
      if (isColorBaseVisible(productData, bases[i], state) && isColorBaseAvailable(productData, bases[i], state)) {
        return bases[i];
      }
    }

    for (i = 0; i < bases.length; i++) {
      if (isColorBaseVisible(productData, bases[i], state)) {
        return bases[i];
      }
    }

    return bases[0] || '';
  }

  function reconcileColorSelection(productData, state) {
    var colorOptionIndex = getColorOptionIndex(productData);
    if (colorOptionIndex < 0) return;

    while (state.selectedOptions.length <= colorOptionIndex) {
      state.selectedOptions.push('');
    }

    var base = getColorBase(state.selectedOptions[colorOptionIndex]);

    if (!base || !isColorBaseVisible(productData, base, state)) {
      state.selectedOptions[colorOptionIndex] = getFirstVisibleColorBase(productData, state);
    } else {
      state.selectedOptions[colorOptionIndex] = base;
    }
  }

  function getVariantOptions(variant) {
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    }); 
  }

  function findVariant(productData, selectedOptions, bandSize) {
    var colorOptionIndex = getColorOptionIndex(productData);

    return (
      productData.variants.find(function (variant) {
        return variantMatchesSelectedOptions(variant, selectedOptions, bandSize, colorOptionIndex);
      }) || null
    );
  }

  function getFirstAvailableVariant(productData, bandSize) {
    return (
      productData.variants.find(function (variant) {
        return variant.available && variantMatchesBandSize(variant, bandSize);
      }) ||
      productData.variants.find(function (variant) {
        return variantMatchesBandSize(variant, bandSize);
      }) ||
      productData.variants[0] ||
      null
    );
  }

  function isOptionValueAvailable(productData, selectedOptions, optionIndex, value, bandSize) {
    var trial = selectedOptions.slice();
    trial[optionIndex] = value;
    var colorOptionIndex = getColorOptionIndex(productData);

    return productData.variants.some(function (variant) {
      if (!variant.available) return false;
      return variantMatchesSelectedOptions(variant, trial, bandSize, colorOptionIndex);
    });
  }

  function getModalById(blockId, root) {
    return root.querySelector('[data-pcard-variant-modal][data-pcard-modal-id="' + blockId + '"]');
  }

  function getVariantDisplayPrices(variant, productData) {
    if (!variant) return null;

    var discountPercent = (productData && productData.discountPercent) || 0;
    var blockOriginal = (productData && productData.blockOriginalPriceCents) || 0;
    var promoPrice = variant.price;
    var originalPrice = blockOriginal;

    if (!originalPrice) {
      if (variant.compareAtPrice && variant.compareAtPrice > promoPrice) {
        originalPrice = variant.compareAtPrice;
      } else {
        originalPrice = promoPrice;
      }
    }

    var currentPrice = promoPrice;
    if (discountPercent > 0) {
      currentPrice = Math.round((promoPrice * (100 - discountPercent)) / 100);
    }

    return {
      compareCents: originalPrice,
      currentCents: currentPrice,
      showCompare: originalPrice > currentPrice
    };
  }

  function updateModalPrices(modal, variant, productData) {
    var pricesEl = modal.querySelector('[data-pcard-modal-prices]');
    if (!pricesEl || !variant) {
      if (pricesEl) pricesEl.innerHTML = '';
      return;
    }

    var prices = getVariantDisplayPrices(variant, productData);
    if (!prices) {
      pricesEl.innerHTML = '';
      return;
    }

    var currentHtml =
      '<span class="section-open-eh-stu-productcard__variant-modal-price-current">' +
      formatMoney(prices.currentCents, productData.moneyFormat) +
      '</span>';

    if (prices.showCompare) {
      currentHtml +=
        '<span class="section-open-eh-stu-productcard__variant-modal-price-compare">' +
        formatMoney(prices.compareCents, productData.moneyFormat) +
        '</span>';
    }

    pricesEl.innerHTML = currentHtml;
  }

  function updateModalSubmitState(modal, variant) {
    var submitBtn = modal.querySelector('[data-pcard-modal-submit]');
    if (!submitBtn) return;
    submitBtn.disabled = !variant || !variant.available;
  }

  function renderOptionGroup(option, productData, state, type) {
    var group = document.createElement('div');
    group.className = 'section-open-eh-stu-productcard__variant-modal-option';
    group.setAttribute('data-pcard-option-group', String(option.position - 1));

    var label = document.createElement('p');
    label.className = 'section-open-eh-stu-productcard__variant-modal-option-label';
    label.textContent = type === 'color' ? 'Kleur' : option.name;
    group.appendChild(label);

    var valuesWrap = document.createElement('div');
    valuesWrap.className =
      'section-open-eh-stu-productcard__variant-modal-option-values' +
      (type === 'color' ? ' section-open-eh-stu-productcard__variant-modal-option-values--color' : '');

    var valuesToRender = option.values;
    if (type === 'color') {
      var seenBases = {};
      valuesToRender = [];
      option.values.forEach(function (optionValue) {
        var base = getColorBase(optionValue.value);
        if (!seenBases[base]) {
          seenBases[base] = true;
          valuesToRender.push({
            value: base,
            swatchColor: optionValue.swatchColor,
            swatchImage: optionValue.swatchImage
          });
        }
      });
    }

    valuesToRender.forEach(function (optionValue) {
      var optionIndex = option.position - 1;
      var isActive =
        type === 'color'
          ? getColorBase(state.selectedOptions[optionIndex]) === getColorBase(optionValue.value)
          : state.selectedOptions[optionIndex] === optionValue.value;
      var isAvailable = isOptionValueAvailable(
        productData,
        state.selectedOptions,
        optionIndex,
        optionValue.value,
        productHasBandSize(productData) ? state.bandSize : null
      );
      var button;

      if (type === 'color') {
        button = document.createElement('button');
        button.type = 'button';
        button.className =
          'section-open-eh-stu-productcard__variant-modal-swatch' + (isActive ? ' is-active' : '');
        button.setAttribute('data-pcard-option-index', String(optionIndex));
        button.setAttribute('data-pcard-option-value', optionValue.value);
        button.setAttribute('data-pcard-color-base', getColorBase(optionValue.value));
        button.disabled = !isAvailable;

        var swatchInner = document.createElement('span');
        swatchInner.className = 'section-open-eh-stu-productcard__variant-modal-swatch-inner';
        if (optionValue.swatchImage) {
          swatchInner.style.backgroundImage = 'url(' + optionValue.swatchImage + ')';
        } else if (optionValue.swatchColor) {
          swatchInner.style.setProperty('--pcard-swatch-bg', optionValue.swatchColor);
          swatchInner.style.background = optionValue.swatchColor;
        }
        button.appendChild(swatchInner);
      } else {
        button = document.createElement('button');
        button.type = 'button';
        button.className =
          'section-open-eh-stu-productcard__variant-modal-pill' + (isActive ? ' is-active' : '');
        button.setAttribute('data-pcard-option-index', String(optionIndex));
        button.setAttribute('data-pcard-option-value', optionValue.value);
        button.textContent = optionValue.value;
        button.disabled = !isAvailable;
      }

      valuesWrap.appendChild(button);
    });

    group.appendChild(valuesWrap);
    return group;
  }

  function syncModalOptionsUI(modal, productData, state) {
    var optionsRoot = modal.querySelector('[data-pcard-modal-options-root]');
    if (!optionsRoot) {
      renderModalOptions(modal, productData, state);
      return;
    }

    var colorOptionIndex = getColorOptionIndex(productData);
    var hasBandSize = productHasBandSize(productData);

    optionsRoot.querySelectorAll('[data-pcard-band-size]').forEach(function (btn) {
      var size = btn.getAttribute('data-pcard-band-size');
      var isActive = state.bandSize === size;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    optionsRoot.querySelectorAll('[data-pcard-option-index]').forEach(function (btn) {
      var optionIndex = parseInt(btn.getAttribute('data-pcard-option-index'), 10);
      var optionValue = btn.getAttribute('data-pcard-option-value');
      var isSwatch = btn.classList.contains('section-open-eh-stu-productcard__variant-modal-swatch');
      var isActive = false;

      if (colorOptionIndex >= 0 && isSwatch && optionIndex === colorOptionIndex) {
        var colorBase = btn.getAttribute('data-pcard-color-base') || getColorBase(optionValue);
        var selectedBase = getColorBase(state.selectedOptions[colorOptionIndex]);
        isActive = selectedBase === colorBase;
        btn.hidden = !isColorBaseVisible(productData, colorBase, state);
        optionValue = colorBase;
      } else {
        isActive = state.selectedOptions[optionIndex] === optionValue;
        btn.hidden = false;
      }

      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      var isAvailable = isOptionValueAvailable(
        productData,
        state.selectedOptions,
        optionIndex,
        optionValue,
        hasBandSize ? state.bandSize : null
      );
      btn.disabled = !isAvailable;
    });
  }

  function renderModalOptions(modal, productData, state) {
    var optionsEl = modal.querySelector('[data-pcard-modal-options]');
    if (!optionsEl) return;

    optionsEl.innerHTML = '';

    if (!productData.options || !productData.options.length) {
      optionsEl.hidden = true;
      return;
    }

    optionsEl.hidden = false;

    var colorOptions = [];
    var otherOptions = [];

    productData.options.forEach(function (option) {
      if (isColorOption(option.name)) {
        colorOptions.push(option);
      } else {
        otherOptions.push(option);
      }
    });

    if (colorOptions.length) {
      var primaryWrap = document.createElement('div');
      primaryWrap.className = 'section-open-eh-stu-productcard__variant-modal-options-primary';
      colorOptions.forEach(function (option) {
        primaryWrap.appendChild(renderOptionGroup(option, productData, state, 'color'));
      });
      optionsEl.appendChild(primaryWrap);
    }

    if (otherOptions.length) {
      for (var i = 0; i < otherOptions.length; i += 2) {
        var row = document.createElement('div');
        row.className = 'section-open-eh-stu-productcard__variant-modal-options-row';
        row.appendChild(renderOptionGroup(otherOptions[i], productData, state, 'pill'));
        if (otherOptions[i + 1]) {
          row.appendChild(renderOptionGroup(otherOptions[i + 1], productData, state, 'pill'));
        }
        optionsEl.appendChild(row);
      }
    }
  }

  function syncModalState(modal, productData, state) {
    if (hasColorOption(productData)) {
      reconcileColorSelection(productData, state);
    }

    syncModalOptionsUI(modal, productData, state);

    var bandSize = productHasBandSize(productData) ? state.bandSize : null;
    var variant =
      findVariant(productData, state.selectedOptions, bandSize) ||
      getFirstAvailableVariant(productData, bandSize);
    state.currentVariantId = variant ? variant.id : null;
    modal._pcardState = state;

    updateModalPrices(modal, variant, productData);
    updateModalSubmitState(modal, variant);

    var qtyValue = modal.querySelector('[data-pcard-qty-value]');
    if (qtyValue) qtyValue.textContent = String(state.quantity);

    var minusBtn = modal.querySelector('[data-pcard-qty-minus]');
    if (minusBtn) minusBtn.disabled = state.quantity <= 1;
  }

  function createModalState(productData) {
    var hasBandSize = productHasBandSize(productData);
    var firstVariant = getFirstAvailableVariant(productData, hasBandSize ? 'Standard' : null);
    var selectedOptions = [];
    var bandSize = hasBandSize ? getBandSizeFromVariant(firstVariant) : null;
    var colorOptionIndex = getColorOptionIndex(productData);

    if (firstVariant) {
      selectedOptions = getVariantOptions(firstVariant);
      if (colorOptionIndex >= 0 && selectedOptions[colorOptionIndex]) {
        selectedOptions[colorOptionIndex] = getColorBase(selectedOptions[colorOptionIndex]);
      }
    } else if (productData.options && productData.options.length) {
      selectedOptions = productData.options.map(function () {
        return '';
      });
    }

    var state = {
      selectedOptions: selectedOptions,
      bandSize: bandSize,
      quantity: 1,
      currentVariantId: firstVariant ? firstVariant.id : null
    };

    if (hasColorOption(productData)) {
      reconcileColorSelection(productData, state);
    }

    return state;
  }

  function closeVariantModal() {
    if (!activeModal) return;

    activeModal.hidden = true;
    activeModal.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
    activeModal = null;
  }

  function openVariantModal(blockId, root) {
    var modal = getModalById(blockId, root);
    var productData = getProductData(blockId, root);
    if (!modal || !productData) return;

    if (activeModal && activeModal !== modal) {
      closeVariantModal();
    }

    var state = createModalState(productData);
    syncModalState(modal, productData, state);

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockPageScroll();
    activeModal = modal;

    var closeBtn = modal.querySelector('.section-open-eh-stu-productcard__variant-modal-close');
    if (closeBtn) closeBtn.focus();
  }

  window.oehStuPcardOpenVariantModal = function (blockId, root) {
    var scope = root || document;
    var sectionRoot = scope.closest
      ? scope.closest('[data-oeh-stu-productcard-root]')
      : document.querySelector('[data-oeh-stu-productcard-root]');
    if (!sectionRoot) return;
    openVariantModal(blockId, sectionRoot);
  };

  window.oehStuPcardCloseVariantModal = closeVariantModal;

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    });
  }

  function destroyVariantModalListeners(root) {
    if (root._pcardModalClickHandler) {
      root.removeEventListener('click', root._pcardModalClickHandler);
      delete root._pcardModalClickHandler;
    }
    delete root.dataset.pcardModalBound;
  }

  function initVariantModal(root) {
    destroyVariantModalListeners(root);

    root._pcardModalClickHandler = function (event) {
      var openBtn = event.target.closest('[data-pcard-open-modal]');
      if (openBtn) {
        event.preventDefault();
        openVariantModal(openBtn.getAttribute('data-pcard-modal-id'), root);
        return;
      }

      var closeTarget = event.target.closest('[data-pcard-modal-close]');
      if (closeTarget && activeModal && root.contains(activeModal)) {
        event.preventDefault();
        closeVariantModal();
        return;
      }

      var optionBtn = event.target.closest('[data-pcard-option-index]');
      if (optionBtn && activeModal && root.contains(activeModal)) {
        var modal = activeModal;
        var productData = getProductData(modal.getAttribute('data-pcard-modal-id'), root);
        if (!productData || !modal._pcardState) return;

        var optionIndex = parseInt(optionBtn.getAttribute('data-pcard-option-index'), 10);
        var optionValue = optionBtn.getAttribute('data-pcard-option-value');
        var state = modal._pcardState;
        var colorOptionIndex = getColorOptionIndex(productData);

        while (state.selectedOptions.length < productData.options.length) {
          state.selectedOptions.push('');
        }

        if (colorOptionIndex >= 0 && optionIndex === colorOptionIndex) {
          state.selectedOptions[optionIndex] = getColorBase(optionValue);
        } else {
          state.selectedOptions[optionIndex] = optionValue;
        }

        syncModalState(modal, productData, state);
        return;
      }

      var bandSizeBtn = event.target.closest('[data-pcard-band-size]');
      if (bandSizeBtn && activeModal && root.contains(activeModal)) {
        var bandModal = activeModal;
        var bandProductData = getProductData(bandModal.getAttribute('data-pcard-modal-id'), root);
        if (!bandProductData || !bandModal._pcardState) return;

        var bandState = bandModal._pcardState;
        bandState.bandSize = bandSizeBtn.getAttribute('data-pcard-band-size');

        syncModalState(bandModal, bandProductData, bandState);
        return;
      }

      var minusBtn = event.target.closest('[data-pcard-qty-minus]');
      if (minusBtn && activeModal && activeModal.contains(minusBtn) && activeModal._pcardState) {
        event.preventDefault();
        if (activeModal._pcardState.quantity > 1) {
          activeModal._pcardState.quantity -= 1;
          syncModalState(
            activeModal,
            getProductData(activeModal.getAttribute('data-pcard-modal-id'), root),
            activeModal._pcardState
          );
        }
        return;
      }

      var plusBtn = event.target.closest('[data-pcard-qty-plus]');
      if (plusBtn && activeModal && activeModal.contains(plusBtn) && activeModal._pcardState) {
        event.preventDefault();
        activeModal._pcardState.quantity += 1;
        syncModalState(
          activeModal,
          getProductData(activeModal.getAttribute('data-pcard-modal-id'), root),
          activeModal._pcardState
        );
        return;
      }

      var submitBtn = event.target.closest('[data-pcard-modal-submit]');
      if (submitBtn && activeModal && activeModal.contains(submitBtn) && activeModal._pcardState) {
        var submitModal = activeModal;
        var submitState = submitModal._pcardState;
        if (!submitState.currentVariantId || submitBtn.disabled) return;

        var submitProductData = getProductData(submitModal.getAttribute('data-pcard-modal-id'), root);
        var submitVariant = findVariantById(submitProductData, submitState.currentVariantId);

        trackPcardAddToCart(root, submitBtn, submitProductData, submitVariant, submitState);

        submitBtn.disabled = true;

        addVariantToCart(submitState.currentVariantId, submitState.quantity)
          .then(function () {
            closeVariantModal();
            if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
              ajaxCart.load();
            } else if (window.routes && window.routes.cart_url) {
              window.location = window.routes.cart_url;
            }
          })
          .catch(function () {
            updateModalSubmitState(
              submitModal,
              findVariant(
                getProductData(submitModal.getAttribute('data-pcard-modal-id'), root),
                submitState.selectedOptions,
                submitState.bandSize
              )
            );
          });
      }
    };

    root.addEventListener('click', root._pcardModalClickHandler);
    root.dataset.pcardModalBound = 'true';
  }

  function destroySwiper(root) {
    ['_pcardSwiper', '_pcardSwiperMb', '_pcardSwiperPc'].forEach(function (key) {
      if (root[key] && typeof root[key].destroy === 'function') {
        root[key].destroy(false, false);
        root[key] = null;
      }
    });
  }

  function getActiveSwiperEl(root) {
    var blockCount = parseInt(root.getAttribute('data-block-count'), 10) || 0;
    var isMobile = isMobileViewport();

    if (blockCount > 2) {
      return isMobile
        ? root.querySelector('[data-pcard-swiper-mb]')
        : root.querySelector('[data-pcard-swiper-pc]');
    }

    return root.querySelector('[data-pcard-swiper]');
  }

  function getSwiperInstanceKey(root) {
    var blockCount = parseInt(root.getAttribute('data-block-count'), 10) || 0;
    var isMobile = isMobileViewport();

    if (blockCount > 2) {
      return isMobile ? '_pcardSwiperMb' : '_pcardSwiperPc';
    }

    return '_pcardSwiper';
  }

  function isCyclingPpMobileStack() {
    return (
      document.body.classList.contains('template-suffix-open-ear-cycling-pp') &&
      isMobileViewport()
    );
  }

  function shouldEnableCarousel(root) {
    if (isCyclingPpMobileStack()) return false;

    var blockCount = parseInt(root.getAttribute('data-block-count'), 10) || 0;
    var isMobile = isMobileViewport();
    return isMobile || blockCount > 2;
  }

  function updateLayoutState(root) {
    var blockCount = parseInt(root.getAttribute('data-block-count'), 10) || 0;
    var isMobile = isMobileViewport();

    root.classList.toggle('is-static-pc', !isMobile && blockCount <= 2);
    root.classList.toggle('is-carousel-pc', !isMobile && blockCount > 2);
    root.classList.toggle('is-mb-stack', isCyclingPpMobileStack());
  }

  function initSwiper(root) {
    if (typeof Swiper === 'undefined') return;

    var blockCount = parseInt(root.getAttribute('data-block-count'), 10) || 0;
    var sectionId = root.getAttribute('data-section-id');
    var enableCarousel = shouldEnableCarousel(root);
    var swiperEl = getActiveSwiperEl(root);
    var swiperKey = getSwiperInstanceKey(root);

    updateLayoutState(root);

    if (!enableCarousel || !swiperEl) {
      destroySwiper(root);
      return;
    }

    if (root[swiperKey]) return;

    root[swiperKey] = new Swiper(swiperEl, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      speed: 500,
      watchOverflow: true,
      breakpoints: {
        767: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 24
        }
      },
      navigation: {
        nextEl: root.querySelector('[data-pcard-next="' + sectionId + '"]'),
        prevEl: root.querySelector('[data-pcard-prev="' + sectionId + '"]')
      },
      pagination: {
        el: root.querySelector('[data-pcard-pagination="' + sectionId + '"]'),
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '" aria-label="Go to slide ' + (index + 1) + '"></span>';
        }
      },
      on: {
        slideChange: function () {
          resetScenesInRoot(root);
          closeVariantModal();
        }
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.pcardInitialized === 'true') return;
    root.dataset.pcardInitialized = 'true';

    initSceneZoom(root);
    initPcardGaTracking(root);
    initPcardViewItemListObserver(root);
    initVariantModal(root);
    initSwiper(root);

    if (!root._pcardResizeBound) {
      root._pcardResizeBound = true;
      window.addEventListener('resize', function () {
        clearTimeout(root._pcardResizeTimer);
        root._pcardResizeTimer = setTimeout(function () {
          destroySwiper(root);
          destroyVariantModalListeners(root);
          destroyPcardViewItemListObserver(root);
          delete root.dataset.pcardInitialized;
          delete root.dataset.pcardSceneBound;
          delete root.dataset.pcardGaBound;
          productDataCache = {};
          initRoot(root);
        }, 200);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-oeh-stu-productcard-root]').forEach(initRoot);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeModal) {
      closeVariantModal();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    resetViewItemListFiredForPath(window.location.pathname);
    document.querySelectorAll('[data-oeh-stu-productcard-root]').forEach(function (root) {
      destroyPcardViewItemListObserver(root);
      initPcardViewItemListObserver(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-oeh-stu-productcard-root]');
    if (!root) return;

    destroySwiper(root);
    destroyVariantModalListeners(root);
    destroyPcardViewItemListObserver(root);
    closeVariantModal();
    delete root.dataset.pcardInitialized;
    delete root.dataset.pcardSceneBound;
    delete root.dataset.pcardGaBound;
    productDataCache = {};
    initRoot(root);
  });
})();
